// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"87ab388d","170":"62a34458","382":"e9ccc21e","392":"102ff6ea","524":"25a8df8c","572":"96172f5a","618":"b667769b","634":"87930178","925":"0cb7f873","989":"5366ce08"}[chunkId] + ".chunk.js";
};